import React from 'react';
import Header from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const DefaultHeader = () => {
	return (
		<Header>
			<CommonHeaderRight />
		</Header>
	);
};

export default DefaultHeader;
